import useThemeHook from "../hooks/useThemeHook";
import { THEME_COLORS } from "../themes/DarkLight";
import Text from "./ThemedText";
export default function CommonPageTitle({
  title,
  padding,
  fontSize,
}: {
  title: string;
  padding: number | null;
  fontSize?: number;
}) {
  const theme = useThemeHook();
  return (
    <Text
      text={title}
      style={{
        textAlign: "center",
        color: THEME_COLORS[theme].inverse_theme,
        margin: 0,
        marginBottom: "10px",
        fontSize: fontSize ?? "30px",
        fontWeight: "500",
        padding: padding ?? 0,
      }}
    />
  );
}
